export default class contextDropdown {

    constructor() {
        const textblockDefinition = [].slice.call(document.querySelectorAll(".text-block-definition"))
        const textblockComment = [].slice.call(document.querySelectorAll(".text-block-definition-box"))

        for (let i = 0, l = textblockDefinition.length; i < l; i++) {
            textblockDefinition[i].addEventListener("click", () => {
                const isOpen = textblockComment[i].classList.contains("text-block-definition-box--active");
                this._closeOthers(textblockComment);

                if (!isOpen) {
                    // create a close-button <span> inside the text-block definition box
                    const textblockCommentCloseButton = document.createElement("span")
                    textblockCommentCloseButton.classList.add("text-block-definition-box-close")
                    textblockCommentCloseButton.addEventListener("click", () => {
                        textblockComment[i].classList.remove("text-block-definition-box--active")
                    })

                    textblockComment[i].appendChild(textblockCommentCloseButton)
                    textblockComment[i].classList.add("text-block-definition-box--active")
                }
            })
        }
    }

    _closeOthers(textblockComments) {
        for (let i = 0; i < textblockComments.length; i++) {
            textblockComments[i].classList.remove("text-block-definition-box--active")
        }
    }
}